import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import Gear from '../../partials/gear';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';
import { getBase64, } from '../../../helpers';
import request from 'superagent';
import config from '../../../config';
import { Popover, PopoverBody, PopoverHeader, } from 'reactstrap';

class AddMedal extends React.Component {
    state = {
        medal: null,
        microTransac: false,
        deleting: false
    }
    componentWillMount() {
        const { medals = [], medalsActions, params } = this.props, { id } = params;
        if (id) {
            if (medals && medals.length && _.find(medals, a => parseInt(a.id, 10) === parseInt(id, 10))) {
                this.setState({ medal: _.find(medals, a => parseInt(a.id, 10) === parseInt(id, 10)) })
            }
            medalsActions && medalsActions.fetchFull(id);
        } else {
            this.setState({ medal: {} });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { medal } = nextProps;
        this.setState({ medal, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    handleMedal = e => {
        const { medal } = this.state;
        getBase64(e.target.files[0]).then(data => {
            medal.Medal = data;
            this.setState({ medal });
        });
    }
    handleBackground = e => {
        const { medal } = this.state;
        getBase64(e.target.files[0]).then(data => {
            medal.Background = data;
            this.setState({ medal });
        });
    }
    save = () => {
        const { medal } = this.state, { medalsActions } = this.props;
        medal.Name = this.txtName.value;
        medal.Description = this.txtDescription.value;

        this.setState({ microTransac: true }, () => {
            request[medal.id ? 'patch' : 'post'](`${config.apiEndpoint}/api/cs/v2/medals${medal.id ? `/${medal.id}` : ''}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .send(medal)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        medalsActions.fetch();
                        this.props.router.push('/admin/medals');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    doDelete = () => {
        const { medal } = this.state, { medalsActions } = this.props;
        this.setState({ microTransac: true }, () => {

            request.del(`${config.apiEndpoint}/api/cs/v2/medals/${medal.id}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        medalsActions.fetch();
                        this.props.router.push('/admin/medals');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    render() {
        const { medal = {}, microTransac } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/medals" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">MEDALS | ADD</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={4} onLogout={this.logout} animated={false} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix padding-right">
                        {medal &&
                            <ScrollAnimation animateIn="fadeInRight" animateOnce={true}>
                                <figure className="card w-100 p-4">
                                    <label htmlFor="name">Medal Name</label>
                                    <input className="" type="text" required ref={(i) => this.txtName = i} defaultValue={medal.Name} />


                                    <label htmlFor="name">Description</label>
                                    <input className="" type="text" required ref={(i) => this.txtDescription = i} defaultValue={medal.Description} />

                                    <div className="car w-100 p-4 d-flex flex-column justify-content-center pointer">
                                        <input type="file" id="medalFU" onChange={this.handleMedal} className="hide" ref={i => this.medalFU = i} />
                                        <label htmlFor="medalFU" className="d-flex flex-column justify-content-center h-100">
                                            {!medal.Medal && <i className='fas fa-plus font-50 align-self-center green' />}
                                            {medal.Medal && <img alt="" style={{ height: 100 }} src={medal.Medal} className="align-self-center" />}
                                            <span className="margin-top-half align-self-center black">{medal.Medal ? 'Change' : 'Add'}{' '}Medal Image</span>
                                        </label>
                                    </div>

                                    <div className="car w-100 p-4 d-flex flex-column justify-content-center pointer">
                                        <input type="file" id="backgroundFU" onChange={this.handleBackground} className="hide" ref={i => this.backgroundFU = i} />
                                        <label htmlFor="backgroundFU" className="d-flex flex-column justify-content-center h-100">
                                            {!medal.Background && <i className='fas fa-plus font-50 align-self-center green' />}
                                            {medal.Background && <img alt="" style={{ height: 100 }} src={medal.Background} className="align-self-center" />}
                                            <span className="margin-top-half align-self-center black">{medal.Background ? 'Change' : 'Add'}{' '}Background Image</span>
                                        </label>
                                    </div>

                                    <div className="d-flex flex-row">
                                        {medal.id && <button id="btn-delete" onClick={this.toggleDelete} type="button" style={{ width: 100 }} className="align-self-center btn-red text-center">REMOVE</button>}
                                        <Link to="/admin/medals" className="align-self-center btn-link text-center ml-auto margin-right black">CANCEL</Link>
                                        <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-white text-center">SAVE</button>
                                    </div>

                                    {medal.id && <Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete`} toggle={this.toggleDelete}>
                                        <PopoverHeader>Are you sure?</PopoverHeader>
                                        <PopoverBody className="d-flex flex-row justify-content-center">
                                            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
                                            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
                                        </PopoverBody>
                                    </Popover>}
                                </figure>
                            </ScrollAnimation>}
                    </section>
                </div>
            </section>
        )
    }
}

export default AddMedal;



// WEBPACK FOOTER //
// ./src/components/private/medals/add.js